<template>
  <div>
    <!-- Ricerca articolo -->
    <v-text-field v-model="codeBarArticolo" label="Articolo" hide-details class="ma-0 pa-2 px-3" @click.stop.prevent
      ref="numOrdine" :append-icon="'search'" @click:append="cercaArticolo()"></v-text-field>

    <!-- Lista articoli -->
    <v-card flat tile v-for="(item, i) in itemsArticoli" :key="i" class="py-2 px-2 has-border-bottom"
      :class="checkArticoloSel(item) ? 'dettaglio--selezionato' : ''" @click="selezionaRiga(item, false, false)"
      style="cursor: pointer">

      <!-- Dati articolo -->
      <div class="intestazione">
        <strong>{{
          $functions.getCodArticoloFormat(item.cdArticoloFiglio)
        }}</strong>
        <v-icon color="green" v-show="checkLettura(item, false)">thumb_up</v-icon>
        <v-icon color="green" v-show="checkLettura(item, true)">thumb_up</v-icon>

        <v-btn v-if="item.ubicazione2" small icon @click.stop="apriDialogDettaQta(item)" class="ma-0"><v-icon
            color="orange">warning</v-icon></v-btn>

        <v-menu transition="slide-x-transition" bottom right>
          <template v-slot:activator="{ on, attrs }">
            <!-- sul button ho aggiunto l'evento click.stop vuoto che evita di richiamare la selezione della riga -->
            <v-btn flat icon color="primary" class="ma-0" absolute right v-bind="attrs" v-on="on" @click.stop=""
              v-if="showBtnPreleva(item.ubicazione)">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-tile class="ma-0 pa-0">
              <span @click.prevent="prelevaMagazzino(item)">
                preleva {{ getUbicazione(item.ubicazione) }}
              </span>
            </v-list-tile>
          </v-list>
        </v-menu>

        <br />
        {{ getDesc(item.descrizioneProdotto) }}
        <br />
        <span style="font-weight: bold">Um:</span>
        {{ item.unMisura }}
        <span style="font-weight: bold">Ubi:</span>
        {{ item.ubicazione }}
        <span style="font-weight: bold">Cf:</span>
        {{ item.cdArticoloFornitore }}
        <br />
        <span style="font-weight: bold">Scaf :</span>
        {{ item.qtaScaffale }}
        <span v-show="tipoEvasione == 'evasione'">
          <span style="font-weight: bold">&nbsp;&nbsp;&nbsp;Ricevuta :</span>
          {{ item.qtaDaStoccare }}
        </span>
        <span v-show="tipoEvasione == 'ricevimento'">
          <span style="font-weight: bold">&nbsp;&nbsp;&nbsp;Bolla :</span>
          {{ item.nrBolla }}
        </span>
        <span v-show="tipoEvasione == 'ricevimento'">
          <span style="font-weight: bold">&nbsp;&nbsp;&nbsp;Ord :</span>
          {{ item.nrDocuStampato }}
        </span>
        &nbsp;&nbsp; {{ item.descrizioneAggiuntiva }}
      </div>

      <!-- Input Qtà -->
      <v-layout style="height: 57px">
        <v-flex xs4 pa-0 pr-2>
          <div class="divQta">
            Ordine
            <br />
            {{ item.qtOrdinata }}
          </div>
        </v-flex>
        <v-flex xs4 pa-0>
          <v-text-field type="number" box label="Evasa" :ref="'txt' + item.idUnivoco" v-bind:value="getQta(item)"
            v-on:input="selectedRow.qtEvasaStoccata = $event" hide-details :background-color="getColore(item)"
            v-if="item.idUnivoco == selectedRow.idUnivoco"></v-text-field>
          <div v-else class="divQta">
            Evasa
            <br />
            {{ getQta(item) }}
          </div>
        </v-flex>
        <v-flex xs4 pa-0 pl-2>
          <div class="divQta" :style="{ backgroundColor: item.parziale ? 'yellow' : '' }">
            Rimanenza
            <br />
            {{ item.qtRimanenza }}
          </div>
        </v-flex>
      </v-layout>

      <!-- Bottone conferma -->
      <v-layout v-if="checkArticoloSel(item) && item.statoEvasione == 0">
        <v-flex xs4 pa-0></v-flex>
        <v-flex xs4 pa-0>
          <v-btn block dark large @click="evadi(tipoEvasione)" :loading="attesaEvasione" :disabled="attesaEvasione"
            color="primary" style="font-size: 13px">Conferma</v-btn>
        </v-flex>
      </v-layout>

    </v-card>
  </div>
</template>

<script>

import {
  evadiRigoOrdine,
  eliminaRigoEvasione,
  get_evasioneOrdine,
  riceviRigoOrdine,
  eliminaRigoRicevimento,
  prelievo_maniglie,
  richiama_cassetto,
} from "@/api/api.js";

export default {
  props: {
    itemsArticoli: { type: Array, default: () => [] },
    codeBar: { type: Object, default: () => ({}) },
    panelRiferimento: { type: Number },
    tipoEvasione: { type: String },
  },

  data: () => ({
    selectedRow: {},

    codeBarArticolo: "",

    attesaEvasione: false,

  }),

  methods: {
    selezionaRiga(item, codeBarLetto, forzatura) {
      // Controllo riga attuale
      // NOTA: selezionaRiga è attivato onClick sulla card, quindi ogni volta che l'utente preme sulla card
      //       verrebbe attivato
      if (
        this.selectedRow.idUnivoco === item.idUnivoco &&
        codeBarLetto == false
      )
        return;

      // Controllo se è in corso una conferma evasione
      if (this.attesaEvasione) return;

      // Reset riga precedente
      if (
        Object.keys(this.selectedRow).length > 0 &&
        this.selectedRow.idUnivoco !== item.idUnivoco
      ) {
        // Ripristino lo zero
        if (this.selectedRow.qtEvasaStoccata == "")
          this.selectedRow.qtEvasaStoccata = 0;

        this.selectedRow.letturaCodebar = false;
      }

      // Memorizzo la letturaCodeBar prima di assegnare this.selectedRow
      let letturaCodeBar =
        Object.keys(this.selectedRow).length > 0
          ? this.selectedRow.letturaCodebar
          : false;

      // Memorizzo la riga attuale
      // NOTA: il campo letturaCodebar viene messo undefined in quanto
      //       è aggiunto al fondo di questa funzione
      this.selectedRow = Object.assign({}, item);

      // Memorizzo nello store l'articolo selezionato
      this.$store.commit("app/setArticoloSelezionato", {
        codArticolo: this.selectedRow.cdArticoloFiglio,
        prog: this.selectedRow.nrRigaDocu,
      });

      // nel caso di evasione completa oppure parziale, tolgo la qta
      // NOTA: potrei anche selezionare tutto il testo ma la select del testo fa comparire
      // su Android "salva, copia, seleziona"
      if (this.selectedRow.qtEvasaStoccata == 0 || this.selectedRow.parziale)
        this.selectedRow.qtEvasaStoccata = "";

      // Imposto lettura codeBar
      this.selectedRow.letturaCodebar = codeBarLetto;

      // Controllo ricevimento (ho il doppio controllo)
      if (this.tipoEvasione == "ricevimento") {
        // Controllo forzatura
        if (forzatura) {
          this.selectedRow.letturaCodebarScaffale = true;
        } else {
          if (letturaCodeBar) {
            this.selectedRow.letturaCodebarScaffale = true;
          }
        }
      }

      // Focus su textbox
      this.$nextTick(() => this.focusCampo());
    },

    focusCampo() {
      let el = this.$refs["txt" + this.selectedRow.idUnivoco][0];
      el.focus();

      // Scroll della card articolo in alto
      el.$parent.$el.scrollIntoView();
      window.scrollBy(0, -50); // Tiene conto della toolbar
    },

    evadi(tipo) {
      if (this.validateQta() == false) {
        return;
      }

      this.attesaEvasione = true;

      let par = {
        nrDocu: this.selectedRow.nrDocu,
        nrRigaDocu: this.selectedRow.nrRigaDocu,
        nrRigaDettaglio: this.selectedRow.nrRigaDettaglio,
        nrRiferimento: this.selectedRow.nrRiferimento,
        cdArticoloFiglio: this.selectedRow.cdArticoloFiglio,
        qtEvasaStoccata: parseFloat(this.selectedRow.qtEvasaStoccata),
        utente: this.$store.getters["user/getDescUser"],
        origine: this.tipoEvasione,
        riceviOrdine: false,
      };

      if (tipo == "evasione") {
        // ----------------
        // ---- EVASIONE --
        // ----------------

        // Controllo presenza qta ricevuta
        // NOTA: nel caso di qta ricevuta, visualizzo un messaggio x fare il ricevimento(stoccaggio)
        if (this.selectedRow.qtaDaStoccare == 0) {
          this.evadiOrdineCliente(par);
        } else {
          // Messaggio di conferma ricevimento rigo
          this.$confirm
            .open("Ricevi", "Vuoi ricevere il rigo ?")
            .then((confirm) => {
              par.riceviOrdine = confirm;

              this.evadiOrdineCliente(par);
            })
            .catch((err) => {
              console.log(this.$functions.getErrorMsg(err));
            });
        }
      } else if (tipo == "ricevimento") {
        // -------------------
        // ---- RICEVIMENTO --
        // -------------------

        this.riceviOrdineFornitore(par);
      } else if (tipo == "ricevimentoEvasione") {
        // -------------------------------
        // ---- RICEVIMENTO DA EVASIONE --
        // -------------------------------

        this.$confirm
          .open("Ricevi", "Vuoi ricevere il rigo ?")
          .then((confirm) => {
            if (!confirm) return;

            par.riceviOrdine = true;

            this.riceviOrdineFornitore(par);
          })
          .catch((err) => {
            console.log(this.$functions.getErrorMsg(err));
          });
      } else if (tipo == "prelievoManiglie") {
        // -------------------------------
        // ------ PRELIEVO MANIGLIE ------
        // -------------------------------
        par.dtConsRichiesta = new Date();

        this.prelievoManiglie(par);
      }
    },

    evadiOrdineCliente(data) {
      evadiRigoOrdine(data)
        .then((res) => {
          this.aggiornaDatiOrdine(res.data);

          // Controllo msg avvisi
          if (res.data.msgAvviso) this.$toast.warning(res.data.msgAvviso);
        })
        .catch((err) => {
          console.log(err);
          this.$toast.info(this.$functions.getErrorMsg(err));
        })
        .finally(() => (this.attesaEvasione = false));
    },

    riceviOrdineFornitore(data) {
      riceviRigoOrdine(data)
        .then((res) => {
          this.aggiornaDatiOrdine(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.$toast.info(this.$functions.getErrorMsg(err));
        })
        .finally(() => (this.attesaEvasione = false));
    },

    prelievoManiglie(data) {
      prelievo_maniglie(data)
        .then((res) => {
          //this.aggiornaDatiOrdine(res.data);
        })
        .catch((err) => {
          console.log(err);
          this.$toast.info(this.$functions.getErrorMsg(err));
        })
        .finally(() => (this.attesaEvasione = false));
    },

    validateQta() {
      if (this.selectedRow.statoEvasione == 1) {
        this.$toast.warning("Rigo già evaso");
        return false;
      }

      if (!this.selectedRow.letturaCodebar) {
        this.$toast.warning("Lettura codice a barre non valida");
        return false;
      }

      if (this.tipoEvasione == "ricevimento") {
        if (!this.selectedRow.letturaCodebarScaffale) {
          this.$toast.warning("Lettura scaffale non valido");
          return false;
        }
      }

      if (this.selectedRow.qtEvasaStoccata.length == 0) {
        this.$toast.warning("Quantità non valida");
        return false;
      }

      let qta = parseFloat(this.selectedRow.qtEvasaStoccata);

      if (qta == 0) {
        this.$toast.warning("Quantità non valida");
        return false;
      }

      if (qta > this.selectedRow.qtOrdinata) {
        this.$toast.warning("Quantità superiore all'ordine");
        return false;
      }

      if (this.tipoEvasione != "prelievoManiglie") {
        if (qta > this.selectedRow.qtRimanenza) {
          this.$toast.warning("Quantità superiore alla rimanenza");
          return false;
        }
      }

      return true;
    },

    eliminaEvasione() {
      if (!this.selectedRow) return;

      if (this.tipoEvasione == "evasione") {
        let par = {
          nrDocu: this.selectedRow.nrDocu,
          nrRiferimento: this.selectedRow.nrRiferimento,
          cdArticoloFiglio: this.selectedRow.cdArticoloFiglio,
        };

        //console.log(par);

        this.$confirm
          .open("Elimina", "Vuoi eliminare l'evasione ?")
          .then((confirm) => {
            if (!confirm) return;

            eliminaRigoEvasione(par)
              .then((res) => {
                this.aggiornaDatiOrdine(res.data);
              })
              .catch((err) => {
                console.log(err);
                this.$toast.info(this.$functions.getErrorMsg(err));
              });
          })
          .catch((err) => {
            console.log(this.$functions.getErrorMsg(err));
          });
      } else if (this.tipoEvasione == "ricevimento") {
        let par = {
          nrDocu: this.selectedRow.nrDocu,
          nrRigaDocu: this.selectedRow.nrRigaDocu,
          cdArticoloFiglio: this.selectedRow.cdArticoloFiglio,
        };

        this.$confirm
          .open("Elimina", "Vuoi eliminare il ricevimento ?")
          .then((confirm) => {
            if (!confirm) return;

            eliminaRigoRicevimento(par)
              .then((res) => {
                this.aggiornaDatiOrdine(res.data);
              })
              .catch((err) => {
                console.log(err);
                this.$toast.info(this.$functions.getErrorMsg(err));
              });
          })
          .catch((err) => {
            console.log(this.$functions.getErrorMsg(err));
          });
      }
    },

    aggiornaDatiOrdine(item) {
      // NOTA: l'idUnivoco cambia dopo aver ricaricato i dati
      //       item.idUnivoco è diverso da this.selectedRow.idUnivoco
      this.$emit("aggiornaDati", item, this.selectedRow.idUnivoco);

      // Reset
      this.resetArticoloSel();
    },

    cercaArticolo() {
      if (this.panelRiferimento == null) return;
      if (!this.codeBarArticolo) return;

      let codice = this.$functions.trimAll(this.codeBarArticolo).toLowerCase();

      // Cerco l'articolo
      let art = this.itemsArticoli.find(
        (f) =>
          f.cdArticoloFiglio.toLowerCase() == codice ||
          f.cdArticoloFornitore.toLowerCase() == codice ||
          f.codiceBarre.toLowerCase() == codice
      );

      // Controllo se l'articolo è stato trovato
      if (art) {
        // Seleziono la riga dell'articolo trovato
        this.selezionaRiga(art, true, false);
      } else {
        this.$toast.warning("Articolo non trovato");
      }
    },

    getColore(item) {
      if (item.qtEvasaStoccata == 0) return "";

      if (item.qtEvasaStoccata < item.qtOrdinata) return "yellow";
      else if (item.qtEvasaStoccata > item.qtOrdinata) return "red";

      return "green";
    },

    checkArticoloSel(item) {
      return this.selectedRow.idUnivoco === item.idUnivoco;
    },

    caricaRigoEvasione() {
      let par =
        this.selectedRow.nrDocu +
        "/" +
        this.selectedRow.nrRiferimento +
        "/" +
        this.selectedRow.cdArticoloFiglio;

      this.attesa = true;

      get_evasioneOrdine(par)
        .then((res) => {
          this.aggiornaDatiOrdine(res.data);
        })
        .catch((err) => {
          console.log(err);

          this.$toast.warning("Ordine non trovato");
        })
        .finally(() => {
          this.attesa = false;
        });
    },

    getQta(item) {
      // Controllo se la riga è selezionata dall'utente
      if (this.selectedRow.idUnivoco === item.idUnivoco)
        return this.selectedRow.qtEvasaStoccata;

      // Nel caso di parziale devo visualizzare 0
      if (item.parziale) return 0;

      // qtEvasaStoccata
      return item.qtEvasaStoccata;
    },

    resetArticoloSel() {
      // Reset riga letta codebar
      this.codeBarArticolo = "";

      this.$store.commit("app/resetArticoloSelezionato");

      this.selectedRow = {};
    },

    checkLettura(item, checkRicevimento) {
      if (checkRicevimento)
        return (
          this.checkArticoloSel(item) &&
          this.selectedRow.letturaCodebar &&
          this.selectedRow.letturaCodebarScaffale
        );
      else
        return this.checkArticoloSel(item) && this.selectedRow.letturaCodebar;
    },

    getDesc(str) {
      return this.$functions.replaceAll(str, '"', "");
    },

    getUbicazione(item) {
      let magazzino = item.substring(0, 2),
        cassetto = item.substring(2, 4);
      if (item.includes("-")) cassetto = item.split("-")[1];
      return "magazzino " + magazzino + " cassetto " + cassetto;
    },

    prelevaMagazzino(item) {
      if (item == null || item.ubicazione == undefined || item.ubicazione == "")
        return;

      let magazzino = item.ubicazione.substring(0, 2),
        cassetto = item.ubicazione.substring(2, 4);
      if (item.ubicazione.includes("-"))
        cassetto = item.ubicazione.split("-")[1];
      let par = {
        Magazzino: magazzino,
        Cassetto: cassetto,
        Utente: this.$store.getters["user/getDescUser"],
      };

      let res = richiama_cassetto(par);
      if (res.data == "OK") this.$toast.info("Comando inviato al magazzino");
      else this.$toast.warning(res.data);
    },

    showBtnPreleva(ubi) {
      if (ubi.length < 2) return false;
      else
        return (
          ubi.substring(0, 2) == 90 ||
          ubi.substring(0, 2) == 92 ||
          ubi.substring(0, 2) == 91
        );
    },

    apriDialogDettaQta(item) {
      this.$emit("apriDialogDettaQta", item)
    },

  },

  mounted() {
    //console.log("mount")
    this.resetArticoloSel();
  },

  computed: {
    getAzione() {
      return this.$store.getters["app/getAzione"];
    },
    getTipo() {
      return this.$store.getters["app/getTipo"].toLowerCase();
    },
  },

  watch: {
    getAzione(v) {
      if (!v) return;

      // NOTA: serve x riattivare il watch (se riclicco sulla stessa azione, non verrebbe attivato)
      this.$store.commit("app/setAzione", "");

      // Controllo presenza riga selezionata
      if (Object.keys(this.selectedRow).length == 0) return;

      if (v == "elimina") {
        this.eliminaEvasione();
      } else if (v == "forzatura") {
        this.selezionaRiga(this.selectedRow, true, true);
      } else if (v == "aggiornaScorta") {
        if (this.tipoEvasione == "evasione") this.caricaRigoEvasione();
        else if (this.tipoEvasione == "ricevimento") {
          // da fare
        }
      } else if (v == "ricevi") {
        if (this.selectedRow.qtaDaStoccare == 0) {
          this.$toast.warning("Nessuna qtà da ricevere");
          return;
        }

        this.evadi("ricevimentoEvasione");
      }
    },

    codeBar(v) {
      // NOTA: viene attivato dal lettore codebar

      this.codeBarArticolo = this.codeBar.barcodeData;

      this.cercaArticolo();
    },

    getTipo() {
      this.resetArticoloSel();
    },

    panelRiferimento(v) {
      this.resetArticoloSel();
    },
  },
};
</script>

<style  scoped>
.intestazione {
  margin: 0;
}

.dettaglio--selezionato {
  /* background-color: rgba(0, 0, 0, 0.1) !important; */
  background-color: #cfd8dc !important;
}

.divQta {
  height: 100%;
  background-color: whitesmoke;
  padding-left: 7px;
  padding-top: 7px;
  border-radius: 4px;
}
</style>